import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import { createStructuredSelector } from "reselect"

import { Link } from "react-router-dom"
import MenuIcon from "@material-ui/icons/Menu"
import ShoppingCart from "@material-ui/icons/ShoppingCartOutlined"

import Badge from "@material-ui/core/Badge"
import ReactCountryFlag from "react-country-flag"

import { selectCurrentUser } from "../../redux/user/user.selectors"
import { selectLanguage } from "../../redux/language/language.selectors"
import { setCurrentUser } from "../../redux/user/user.actions"

import EN_DATA from "../../data/language/english.data"
import PT_DATA from "../../data/language/portuguese.data"

import "./BurgerMenu.scss"

function BurgerMenu({ language, currentUser, setCurrentUser, onLanguage }) {
  const menu = language === "EN" ? EN_DATA.menu : PT_DATA.menu
  const [open, setOpen] = useState(false)

  const readCartCount = () => {
    try {
      const raw = localStorage.getItem("userCart")
      if (!raw) return 0
      const parsed = JSON.parse(raw)
      return Array.isArray(parsed) ? parsed.length : 0
    } catch {
      return 0
    }
  }

  const [badgeCount, setBadgeCount] = useState(readCartCount())

  useEffect(() => {
    setBadgeCount(readCartCount())
    const onStorage = () => setBadgeCount(readCartCount())
    window.addEventListener("storage", onStorage)
    return () => window.removeEventListener("storage", onStorage)
  }, [])

  function handleLogout() {
    setCurrentUser()

    const keepLanguage = localStorage.getItem("language")
    localStorage.clear()
    if (keepLanguage) localStorage.setItem("language", keepLanguage)

    setBadgeCount(0)
  }

  return (
    <div>
      <div
        className={`burger-menu ${open ? "" : ""}`}
        onClick={() => setOpen(!open)}
      >
        <MenuIcon />
      </div>

      <div className={`nav-right ${open ? "" : "hide"}`}>
        <Link
          onClick={() => {
            window.scrollTo(0, 0)
            setOpen(false)
          }}
          to="/"
        >
          {menu[0]}
        </Link>

        <a href="/#services" onClick={() => setOpen(false)}>
          {menu[1]}
        </a>
        <a href="/#about-us" onClick={() => setOpen(false)}>
          {menu[2]}
        </a>
        <a href="/gallery" onClick={() => setOpen(false)}>
          {menu[3]}
        </a>
        <a href="/#contact" onClick={() => setOpen(false)}>
          {menu[4]}
        </a>

        {currentUser?.type === 0 ? (
          <Link to="/dashboard" onClick={() => setOpen(false)}>
            ADMIN
          </Link>
        ) : (
          ""
        )}

        {currentUser ? (
          <Link
            onClick={() => {
              handleLogout()
              setOpen(false)
            }}
            to="/"
          >
            {menu[6]}
          </Link>
        ) : (
          <Link to="/login" onClick={() => setOpen(false)}>
            {menu[5]}
          </Link>
        )}

        {/* Language switch (no modal here) */}
        <div className="burger-language">
          <div
            className={`lang-item ${language === "EN" ? "active" : ""}`}
            onClick={() => onLanguage && onLanguage("EN")}
          >
            <ReactCountryFlag
              countryCode="IE"
              svg
              style={{ fontSize: "1.6em", lineHeight: "1.6em" }}
            />
            <span className="lang-label">EN</span>
          </div>

          <div
            className={`lang-item ${language === "BR" ? "active" : ""}`}
            onClick={() => onLanguage && onLanguage("BR")}
          >
            <ReactCountryFlag
              countryCode="BR"
              svg
              style={{ fontSize: "1.6em", lineHeight: "1.6em" }}
            />
            <span className="lang-label">PT-BR</span>
          </div>
        </div>

        <Link
          to="/cart"
          onClick={() => setOpen(false)}
          style={{ display: "flex", alignItems: "center", gap: "8px" }}
        >
          <Badge badgeContent={badgeCount} color="primary">
            <ShoppingCart />
          </Badge>
          <span>Cart</span>
        </Link>
      </div>
    </div>
  )
}

const mapStateToProps = createStructuredSelector({
  currentUser: selectCurrentUser,
  language: selectLanguage,
})

const mapDispatchToProps = (dispatch) => ({
  setCurrentUser: (user) => dispatch(setCurrentUser(user)),
})

export default connect(mapStateToProps, mapDispatchToProps)(BurgerMenu)
